<template>
<div class="chapter">
<div class="inner_page">
<h1><a id="page_8"></a><span class="caps">Big Daddies,<br/>
  a Thankless Task</span></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_part02.vue?9092d31e